// relative
import type { MoveNodeFormValues } from './moveNodeForm.schema';

export function toMoveNodeFormValues(
  parentId?: string | null,
): MoveNodeFormValues {
  return {
    parentId: parentId ?? null,
  };
}

export function toMoveNodePayload(values: MoveNodeFormValues): {
  parentId: string;
} {
  return {
    parentId: values.parentId!,
  };
}
